<template>
  <v-container fluid class="equipmentBRC-management mt-4 px-1">
    <v-row>

      <!-- Modal ชื่อ dialogRemark -->
      <v-dialog v-model="dialogRemark" max-width="850px">
        <v-card>
          <v-card-title>
            <span class="text-h6">สถานะเอกสาร</span>
          </v-card-title>
          <v-card-text>

            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                :headers="remark_headers"
                :items="remark_items"
                item-value="id"
            >
              <!-- Template สำหรับคอลัมน์ updated_at -->
              <template v-slot:item.updated_at="{ item }">
                <span>{{ dataFormatter.dateFormatterTH(item.updated_at, 1) }}</span>
              </template>


              <template v-slot:item.borrowing_status="{ item }">
    <span
        v-if="getStatusData(item.borrowing_status)"
        :class="`v-chip theme--light v-size--small ${getStatusData(item.borrowing_status).color}`"
    >
      <span class="v-chip__content">{{ getStatusData(item.borrowing_status).title_th }}  </span>
    </span>
                <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>

              </template>


            </v-data-table>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                outlined
                class="button-shadow mr-4"
                @click="dialogRemark = false"
            >
              ปิด
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-col cols="12">

        <!--หน้าแรก แสดงรายการ-->
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>รับรองการยืมวัสดุอุปกรณ์</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{
              '\xa0 (' + equipmentBRCs.length
            }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      @change="searchData"
                      v-model="search_data.borrowing_status"
                      :items="borrowing_status_text_color"
                      item-text="title_th"
                      item-value="status_code"
                      label="สถานะเอกสาร"
                      clearable=""
                  ></v-select>

                </v-col>



                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>

            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting || isUpdating"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="equipmentBRCs"
                :search="search"
                sort-by="item_id">
              <template v-slot:top>



              </template>

              <template v-slot:item.created_at="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.created_at, 3) }}</span>
              </template>


              <template v-slot:item.borrowing_title="{ item }">
                <span> {{item.borrowing_title}} <sup v-if="item.fname_th!='undefined' && item.fname_th!=null">{{item.fname_th+' '+item.lname_th}} </sup></span>
              </template>


              <template v-slot:item.start_date="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.start_date, 3) }}</span>
              </template>

              <template v-slot:item.end_date="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.end_date, 3) }}</span>
              </template>


              <template v-slot:item.borrowing_status="{ item }">
    <span
        v-if="getStatusData(item.borrowing_status)"
        :class="`v-chip theme--light v-size--small ${getStatusData(item.borrowing_status).color}`"
    >
      <span class="v-chip__content">{{ getStatusData(item.borrowing_status).title_th }}</span>
    </span>
                <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>
                <v-btn icon small @click="showRemark(item.borrowing_id)">
                  <v-icon color="greyTint" title="สถานะเพิ่มเติม">mdi-information</v-icon>
                </v-btn>
              </template>


              <template v-slot:item.api="{ item }">

                <v-btn
                    @click="downloadReport(item.borrowing_id,'pdf')"
                    small
                    class="mr-3 button-shadow"
                    color="warning"
                >ใบยืม
                </v-btn>


                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                    :disabled="!borrowing_status_text_color.find(items => items.status_code === item.borrowing_status).certified && currentUser.role!='admin'"
                >รับรอง
                </v-btn>


                <v-btn
                    @click="updateBorrowingStatus('RN',item)"
                    small
                    class="button-shadow"
                    color="secondary"
                    :disabled="!borrowing_status_text_color.find(items => items.status_code === item.borrowing_status).nocertified && currentUser.role!='admin' "
                >ไม่รับรอง
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <!--หน้าสำหรับเพิ่ม / แก้ไข-->
        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.borrowing_id"
                      :rules="editForm.textReqRules"
                      label="รหัสเอกสาร"
                      required
                      readonly
                      disabled

                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.created_at_text"
                      :rules="editForm.textReqRules"
                      label="วันที่เอกสาร"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.full_name_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อ-นามสกุล (ผู้ยืม)"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.job_title"
                      :rules="editForm.textReqRules"
                      label="สังกัด"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.phone_number"
                      :rules="editForm.textReqRules"
                      label="หมายเลขโทรศัพท์"
                      disabled
                      required
                  ></v-text-field>


                </v-col>


              </v-row>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="2">

                  <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"

                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          @change="clearableDate('start')"
                          v-model="dateFormatted3"
                          label="วันที่จะรับวัสดุอุปกรณ์"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="editForm.textReqRules"
                          clearable
                          disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker

                        v-model="date3"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>
                <v-col class="d-flex" cols="12" sm="2">

                  <v-menu
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          @change="clearableDate('end')"
                          v-model="dateFormatted4"
                          label="วันที่จะคืนวัสดุอุปกรณ์"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="editForm.textReqRules"
                          clearable
                          disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date4"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>

                <v-col class="d-flex" cols="12" sm="8">
                  <v-text-field
                      v-model="editForm.borrowing_title"
                      :rules="editForm.textReqRules"
                      label="เพื่อใช้ในงาน"
                      required
                      disabled
                  ></v-text-field>


                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4" v-if="checkType(editForm.user_name)">


                  <v-select
                      v-model="editForm.certifier_user_name"
                      :items="users_combo"
                      item-text="full_name_th"
                      item-value="user_name"
                      :rules="editForm.textReqRules"
                      label="ผู้รับรองการยืม (กรณีนิสิต)"
                      clearable=""
                      disabled
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" :sm="checkType(editForm.user_name)==true?8:12">
                  <v-text-field
                      v-model="editForm.borrowing_place_title"
                      :rules="editForm.textReqRules"
                      label="สถานที่ที่นำไปใช้"
                      required
                      disabled
                  ></v-text-field>


                </v-col>
              </v-row>


              <v-card class="mb-1">


                <v-card-title class="pa-5 pb-3">
                  <p>รายการวัสดุอุปกรณ์</p>
                  <span class="grey--text font-weight-regular subtitle-2 pt-1">{{
                      '\xa0 (' + this.equipment_br_items.length
                    }} รายการ) </span>
                  <v-spacer></v-spacer>

                </v-card-title>

                <v-card-text class="px-5">
                  <v-row>
                    <v-col class="d-flex" cols="12" sm="12">
                      <v-data-table style="width: 100%"
                                    :loading="isReceiving || isDeleting"
                                    loading-text="Loading... Please wait"
                                    class="product-table"
                                    :headers="equipment_headers"
                                    :options="equipment_options"
                                    :items="this.equipment_br_items"
                                    sort-by="borrowing_id">
                        <template v-slot:top>


                        </template>


                        <template v-slot:item.item_id_full="{ item }">
                          {{ item.item_id_full.item_name }}

                        </template>

                        <template v-slot:item.return_status="{ item }">
    <span
        v-if="getReturnStatusData(item.return_status)"
        :class="`v-chip theme--light v-size--small ${getReturnStatusData(item.return_status).color}`"
    >
      <span class="v-chip__content">{{ getReturnStatusData(item.return_status).title_th }}</span>
    </span>
                          <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>
                        </template>






                      </v-data-table>
                    </v-col>

                  </v-row>


                </v-card-text>


              </v-card>


              <br>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>

                    <v-btn

                        color="primary"
                        class="button-shadow mr-4"
                        @click="updateBorrowingStatus('AC')">
                      รับรองการยืม
                    </v-btn>

                    <v-btn

                        color="secondary"
                        class="button-shadow mr-4"
                        @click="updateBorrowingStatus('RN')">
                      ไม่รับรอง
                    </v-btn>

                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>

    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import dataFormatter from "@/use/dataFormatter";
import axios from "axios";


export default {
  name: 'EquipmentBRC',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu2: false,
      date3: '',
      date4: '',
      dateFormatted3: '',
      dateFormatted4: '',
      menu3: false,
      menu4: false,

      dialogRemark: false,

      state: 'index',
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      search: '',
      search_data: {
        borrowing_status: "",
        start_date: '',
        end_date: '',
      },
      selected: [],
      headers: [
        {
          text: 'รหัสเอกสาร',
          align: 'start',
          value: 'borrowing_id',
        },
        {text: 'วันที่เอกสาร', value: 'created_at'},
        {text: 'เพื่อใช้ในงาน', value: 'borrowing_title'},
        {text: 'กำหนดรับ', value: 'start_date'},
        {text: 'กำหนดส่งคืน', value: 'end_date'},
        {text: 'สถานะเอกสาร', value: 'borrowing_status'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ["borrowing_id"],
        sortDesc: [true]
      },
      e_i_tem_type_master_combo: [],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
        activity_id_search: '',
        activity_id_search_history: new Set() ,
      },


      equipment_br_items: [],  // desserts
      editedEquipmentIndex: -1, //editedIndex
      editedEquipmentItem: {  //editedItem
        item_id_full: null,
        item_h_image: null,
        item_id: '',
        item_quantity: 0,
        borrowing_list_quantity: 0,
        remarks: ''
      },
      defaultEquipmentItem: { //defaultItem
        item_id: '',
        item_quantity: 0,
        borrowing_list_quantity: 0,
        remarks: ''
      },


      equipment_headers: [
        {
          text: 'รายการ',
          align: 'start',
          value: 'item_id',
        },
        {
          text: 'รายการ',
          value: 'item_id_full',
        },
        {text: 'จำนวน', value: 'borrowing_list_quantity'},
        {text: 'หมายเหตุ', value: 'remarks'},
        {text: 'สถานะ', value: 'return_status'},

      ],
      equipment_options: {
        sortBy: ['updated_at'],
        sortDesc: [true]
      },
      e_i_tem_combo: {},
      borrowing_status_text_color: [
        {
          "status_code": "RR",
          "title_th": "รอรับรอง/รอเสนอ",
          "title_en": "Requesting Review",
          "color": "warning",
          "certified":true,
          "nocertified":true,

        },
        {
          "status_code": "RN",
          "title_th": "ไม่รับรอง",
          "title_en": "Review Not Accepted",
          "color": "default",
          "certified":true,
          "nocertified":false,
        },
        {
          "status_code": "AC",
          "title_th": "รับรองแล้ว",
          "title_en": "Accepted Certification",
          "color": "success",
          "certified":false,
          "nocertified":true,
        },
        {
          "status_code": "PA",
          "title_th": "อยู่ระหว่างเสนอ",
          "title_en": "Process Approval",
          "color": "warning",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "AN",
          "title_th": "ไม่อนุมัติ",
          "title_en": "Approval Not Granted",
          "color": "default",
          "certified":true,
          "nocertified":true,
        },
        {
          "status_code": "AP",
          "title_th": "อนุมัติแล้ว",
          "title_en": "Approval Provided",
          "color": "success",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "PE",
          "title_th": "เตรียมอุปกรณ์",
          "title_en": "Preparing Equipment",
          "color": "secondary",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "PS",
          "title_th": "เตรียมเสร็จ",
          "title_en": "Preparation Successful",
          "color": "success",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "RC",
          "title_th": "รับแล้ว",
          "title_en": "Received Confirmation",
          "color": "success",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "RT",
          "title_th": "คืนแล้ว",
          "title_en": "Returned",
          "color": "secondary",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "ER",
          "title_th": "มีข้อผิดพลาด",
          "title_en": "Error Reported",
          "color": "default",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": "CX",
          "title_th": "ยกเลิก",
          "title_en": "Cancelled Execution",
          "color": "default",
          "certified":false,
          "nocertified":false,
        }
      ],
      return_status_text_color: [
        {
          "status_code": 0,
          "title_th": "เตรียม",
          "color": "warning",
          "certified":true,
          "nocertified":true,
        },
        {
          "status_code": 1,
          "title_th": "รับแล้ว",
          "color": "default",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": 2,
          "title_th": "คืนแล้ว",
          "color": "success",
          "certified":false,
          "nocertified":false,
        },
        {
          "status_code": 3,
          "title_th": "ชำรุด",
          "color": "warning",
          "certified":false,
          "nocertified":false,
        }

      ]
      ,
      users_combo: {},
      e_activity_combo: {},

      activity_items: [],  // desserts
      activity_headers: [
        {
          text: 'รายการแนะนำ',
          align: 'start',
          value: 'item_id',
        },
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      activity_options: {
        sortBy: ['activity_id', 'rule_priority'],
        sortDesc: [true, true]
      },
      remark_items: [],
      remark_headers: [

        {text: 'สถานะเอกสาร', value: 'borrowing_status'},
        {text: 'หมายเหตุ', value: 'remark'},
        {text: 'วันที่ทำรายการ', value: 'updated_at'},
        {text: 'บันทึกโดย', value: 'created_by'},

      ],
    }
  },
  components: {},
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('equipment_brcs', ['equipmentBRCs', "isReceiving", "isDeleting", "idToDelete", "equipmentBRCMessage", "isUpdating", "errorMessage"]),

    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'รับรองรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    //Date Picker Format
    computedDateFormatted3() {
      return this.formatDate(this.date3)
    },

    //Date Picker Format
    computedDateFormatted4() {
      return this.formatDate(this.date4)
    },

    computedDateMonthFormatted() {
      return this.formatDateMonth(this.datemonth)
    },
    //getDataUserLogin
    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    equipmentBRCMessage() {

      if (this.equipmentBRCMessage !== '') {
        this.notification = this.equipmentBRCMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },
    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    date3() {
      this.dateFormatted3 = this.formatDate(this.date3)
      this.checkStartEnd();
    },

    date4() {
      this.dateFormatted4 = this.formatDate(this.date4)
      this.checkStartEnd();
    },
    datemonth() {
      this.datemonthFormatted = this.formatDateMonth(this.datemonth)
    },




  },
  created() {
    this.addSuccessNotification();

  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getEquipmentBRCsRequest(this.search_data);
    this.getUsersActive();
    this.getEActivityActive();
    this.resetValue();
    //Equipment
    this.getEItem();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('equipment_brcs',
        [
          "getEquipmentBRCsRequest",
          "deleteEquipmentBRCRequest",
          "updateEquipmentBRCRequest"

        ]
    ),
    ...mapActions('web_con_new_images', ["getWeb_con_new_imagesRequest"]),



    showAlert(title,icon) {
      this.$swal({
        title: "ขออภัย!",
        text: title,
        icon: icon,
        confirmButtonText: 'ตกลง',
      });
    },


    resetValue() {
      this.editForm = {} //set null all value
      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        activity_id_search: '',
        activity_id_search_history: new Set() ,
        imageRules: validateRules.fileSingleRules(3),
        item_id: null,
        item_type_master_code: '',
        item_name: '',
        active: 'N',
        preview: '',
        avatarFile: null,
        avatarFileOld: null,
      }
    },

    async fetchActivityItems() {
      // Start loading indicator
      //this.isReceiving = true;

      try {
        //  ดึงข้อมูลตามกิจกรรมที่เลือก
        const selectedIds = this.editForm.activity_id_search;

        console.log(selectedIds);
        if (selectedIds.length > 0) {


          const formData = new FormData();
          formData.append('activity_id_search', JSON.stringify(selectedIds)); // ส่งเป็น JSON string

          await axios.post(config.baseURLApi + '/get_eitem_activity', formData, {
            headers: {},
          }).then(res => {
            this.activity_items = res.data
          });


        } else {
          this.activity_items = []; // Clear data if no activity selected
        }
      } catch (error) {
        console.error("Error fetching activity items:", error);
      } finally {
        // Stop loading indicator
        //this.isReceiving = false;
      }
    },


    async getUsersActive() {

      try {

        await axios.post(config.baseURLApi + '/combo/' + 'usersActive', '', {
          headers: {},
        }).then(res => {
          this.users_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },

    async getEActivityActive() {

      try {

        await axios.post(config.baseURLApi + '/combo/' + 'eActivityActive', '', {
          headers: {},
        }).then(res => {
          this.e_activity_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },


    async getEItem() {

      console.log(this.date3 + '-' + this.date4)
      try {

        await axios.post(config.baseURLApi + '/combo/' + 'eItem', '', {
          headers: {},
        }).then(res => {
          this.e_i_tem_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },

    async getBorrowingList(borrowing_id) {
      console.log(borrowing_id);

      try {
        const formData = new FormData();
        formData.append('borrowing_id', borrowing_id);

        await axios.post(config.baseURLApi + '/con_equipment_br_items', formData, {
          headers: {},
        }).then(res => {

          console.log(res.data);

          if (res.data.length > 0) {
            res.data.forEach(item => {
              item.item_id_full = this.getItemDetailsById(item.item_id);
            });
          }
          this.equipment_br_items = res.data;

        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },


    async editItem(item) {

      const isValid = await this.checkBorrowingStatus(item.borrowing_status,'edit');

      if (isValid) {
        this.resetValue();
        this.editedIndex = this.equipmentBRCs.indexOf(item) //index ของ row ที่จะแก้ไข
        this.editForm.borrowing_id = item.borrowing_id * 1;
        this.editForm.user_name = item.user_name;
        this.editForm.borrowing_title = item.borrowing_title;
        this.editForm.borrowing_place_title = item.borrowing_place_title;

        // this.editForm.start_date = item.start_date;
        this.date3 = item.start_date;
        this.dateFormatted3 = this.formatDate(item.start_date);

        // this.editForm.end_date = item.end_date;
        this.date4 = item.end_date;
        this.dateFormatted4 = this.formatDate(item.end_date);
        this.editForm.certifier_user_name = item.certifier_user_name;
        this.editForm.borrowing_status = item.borrowing_status;
        this.editForm.created_at_text = dataFormatter.dateFormatterTH(item.created_at, 3);
        this.editForm.job_title = item.job_title;
        this.editForm.full_name_th = item.fname_th + ' ' + item.lname_th;
        this.editForm.phone_number = item.phone_number;

        this.getBorrowingList(item.borrowing_id * 1); // get lis item to equipment_br_items

        this.state = 'editForm';
      }


    },


    close() {

      if (this.errorMessage == false || this.equipmentBRCMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

 /*     // สร้าง เพิ่ม list เข้าไปใน editForm
      this.editForm.start_date = this.date3;
      this.editForm.end_date = this.date4;
      this.editForm.equipment_br_items = this.equipment_br_items;
      console.log(this.equipment_br_items)

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.equipmentBRCs[this.editedIndex], this.editForm)
            :
            this.updateEquipmentBRCRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.equipmentBRCs.push(this.editForm)
            :
            this.createEquipmentBRCRequest(this.editForm)
      }*/

    },
    async  updateBorrowingStatus(status,item=null){

      if(item!=null){
        this.editForm.borrowing_id = item.borrowing_id;
      }



      this.$swal({
        title: 'ยืนยัน ' + (status == 'AC' ? 'รับรอง' : 'ไม่รับรอง'),
        html: "คุณแน่ใจหรือไม่ว่าต้องการดำเนินการนี้? <br>" + (status == 'AC' ? 'เงื่อนไขความรับผิดชอบจะเป็นไปตามข้อกำหนดของคณะรัฐศาสตร์และสังคมศาสตร์' : 'สามารถระบุหมายเหตุได้ในช่องข้อความ'),
        icon: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน/ยอมรับ',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          // ทำการดำเนินการเมื่อยืนยัน
          //console.log('status:', status)
         // console.log('ข้อความที่ป้อน:', result.value || 'ไม่มีข้อความ')

          this.editForm.borrowing_status = status;
          this.editForm.remark = result.value;
          !config.isBackend ?
              Object.assign(this.equipmentBRCs[this.editedIndex], this.editForm)
              :
              this.updateEquipmentBRCRequest(this.editForm)


        } else {
          //console.log('status:', status)
          // ทำการดำเนินการเมื่อยกเลิก
        }
      });









      /*alert('เรียกคำสั่งยืนยันการรับรอง ')
      !config.isBackend ?
          Object.assign(this.equipmentBRCs[this.editedIndex], this.editForm)
          :
          this.updateEquipmentBRCRequest(this.editForm)*/

    },
    downloadReport(borrowing_id,extension){
      var url = config.baseURLApi + '/report/equipment_master_r_001?borrowing_id='+borrowing_id+'&extension='+extension
      window.open(url);
    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },


    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },
    formatDateMonth(date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    parseDateMonth(date) {
      if (!date) return null
      const [month, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}`
    },

    clearableDate(item) {
      if (item == 'start') {
        this.date3 = '';
      } else {
        this.date4 = '';
      }
      this.searchData();

    },
    checkStartEnd() {
      if (this.date3 != '' && this.date4 != '') {

        // แปลง string เป็น Date objects
        var startDateObject = new Date(this.date3);
        var endDateObject = new Date(this.date4);

        // เปรียบเทียบวันที่
        if (startDateObject > endDateObject) {

          this.showAlert("วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด","warning")
          this.date3 = ''

        } else if (endDateObject < startDateObject) {
          this.showAlert("วันที่สิ้นสุด น้อยกว่า วันที่เริ่มต้น","warning")
          this.date4 = ''

        }
      }
    },

    async checkBorrowingStatus(status,type) {

      //เช็ค ถ้าไม่ใช่ admin

      if(type=='edit'){
        if(!this.borrowing_status_text_color.find(item => item.status_code === status).certified&& this.currentUser.role!='admin'){
          this.showAlert("สถานะเอกสารปัจจุบัน ไม่สามารถแก้ไขได้","warning");
          return false;
        }
      }else{
        if(!this.borrowing_status_text_color.find(item => item.status_code === status).nocertified&& this.currentUser.role!='admin'){
          this.showAlert("สถานะเอกสารปัจจุบัน ไม่สามารถยกเลิกได้","warning");

          return false;
        }
      }

      return true;

    },


    showRemark(borrowing_id){
      this.remark_items =[];
      try {
        const formData = new FormData();

        formData.append('borrowing_id', borrowing_id);

        axios.post(config.baseURLApi + '/get_e_borrowing_log', formData, {
          headers: {},
        }).then(res => {

          this.remark_items = res.data

          console.log("remark")
          console.log(res.data)
          this.dialogRemark = true

        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },

    // ฟังก์ชันสำหรับดึงข้อมูล
    getItemDetailsById(itemId) {
      // ใช้ find() เพื่อค้นหา item_id ที่ตรงกัน
      const itemDetails = this.e_i_tem_combo.find(item => item.item_id === itemId);
      return itemDetails || null;
    },


    searchData() {
      this.checkStartEnd();
      this.search_data.start_date = this.date3;
      this.search_data.end_date = this.date4;
      this.getEquipmentBRCsRequest(this.search_data);
    },

    getStatusData(status) {
      return this.borrowing_status_text_color.find((item) => item.status_code === status) || null;
    },
    getReturnStatusData(status) {
      return this.return_status_text_color.find((item) => item.status_code === status) || null;
    },

    checkType(user_name) {

      //เช็ครูปแบบ user name ว่าเป็น นิสิต/บุคลากร
      if (typeof user_name === "string" && !isNaN(user_name)) {
        return true;
        // console.log("user_name เป็นตัวเลข (ในรูปแบบข้อความ)");
      } else if (typeof user_name === "string") {
        return false;
        //console.log("user_name เป็นข้อความ");
      } else if (typeof user_name === "number") {
        return true;
        // console.log("user_name เป็นตัวเลข");//
      } else {
        return false;
        //console.log("user_name เป็นชนิดอื่น");
      }
    },

    async beforeMount() {

    },

  }
  ,
}
</script>

<style src="../EquipmentBRC/EquipmentBRC.scss" lang="scss"/>
